;(function () {
  var shopUrl = window.location.hostname
  var formID = ""

  if (shopUrl.includes("eu.etnies.com")) {
    formID = "Sj7rhG"
  } else if (shopUrl.includes("etnies.com")) {
    formID = "TZTZe9"
  }

  if (formID) {
    var btn = document.getElementById("klaviyo-signup-btn")
    btn.href = "javascript:void(0);"
    btn.setAttribute(
      "onclick",
      "window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', '" +
        formID +
        "']);"
    )
  }
})()
